import { markProgressStep, ProgressStep } from './progress.ts';

const ACTIVE_CLASS = 'is-active';
const ACTIVE_LABEL_CLASS = 'is-active-label';
const AUTO_SELECT_DELAY_MS = 1000;

function initTricks(): void {
  const tableBody = document.querySelector('#tricks .table-three-column tbody');
  if (!tableBody) return;

  const rows = Array.from(tableBody.querySelectorAll('tr'));
  if (!rows.length) return;
  let progressMarked: boolean = false;
  let activeRow: HTMLTableRowElement | null = null;
  const hoveredRows = new Set<HTMLTableRowElement>();
  let autoSelectTimer: number | null = null;

  const markProgressIfNeeded = (): void => {
    if (progressMarked) return;
    markProgressStep(ProgressStep.TRICKS_VISITED);
    progressMarked = true;
  };

  const isMobileView = (): boolean => window.matchMedia('(max-width: 640px)').matches;

  const cancelInitialSelection = (): void => {
    if (autoSelectTimer !== null) {
      window.clearTimeout(autoSelectTimer);
      autoSelectTimer = null;
    }
  };

  const setRowState = (row: HTMLTableRowElement, isActive: boolean): void => {
    if (!row) return;
    row.classList.toggle(ACTIVE_CLASS, isActive);
    const labelCell = row.querySelector('td:first-child');
    if (labelCell) {
      labelCell.classList.toggle(ACTIVE_LABEL_CLASS, isActive);
    }
    row.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  };

  const toggleRow = (row: HTMLTableRowElement): void => {
    if (activeRow === row) {
      setRowState(row, false);
      activeRow = null;
      return;
    }

    if (activeRow) {
      setRowState(activeRow, false);
    }

    setRowState(row, true);
    activeRow = row;
  };

  const firstRow = rows[0] || null;
  if (firstRow) {
    cancelInitialSelection();
    if (isMobileView()) {
      autoSelectTimer = window.setTimeout(() => {
        autoSelectTimer = null;
        if (activeRow || !isMobileView()) {
          return;
        }
        activeRow = firstRow;
        setRowState(firstRow, true);
      }, AUTO_SELECT_DELAY_MS);
    }
  }

  rows.forEach((row) => {
    row.setAttribute('tabindex', '0');
    row.classList.add('is-interactive');
    if (row !== activeRow) {
      setRowState(row, false);
    }

    row.addEventListener('click', () => {
      cancelInitialSelection();
      markProgressIfNeeded();
      toggleRow(row);
    });

    row.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        cancelInitialSelection();
        markProgressIfNeeded();
        toggleRow(row);
      }
    });

    row.addEventListener('mouseenter', () => {
      if (progressMarked) return;
      hoveredRows.add(row);
      if (hoveredRows.size >= 3) {
        markProgressIfNeeded();
      }
    });
  });
}

export { initTricks };
